import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Note } from '../..';
export const title = 'Using Rebass without Context';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "using-rebass-without-context"
    }}>{`Using Rebass without Context`}</h1>
    <p>{`If you'd like to use Rebass components without adding a theme to React context,
you can pass a `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object as a prop to any of the components.`}</p>
    <Note mdxType="Note">
      <p>{`This guide is a work-in-progress.
If you'd like to help make this better,
please open an issue or pull request on `}<a parentName="p" {...{
          "href": "https://github.com/rebassjs/rebass"
        }}>{`GitHub`}</a>{`.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import { Box } from 'rebass'
import theme from './theme'

export default props =>
  <Box
    {...props}
    theme={theme}
  />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      